import { useState } from "react"
import ReportService from "../services/api/reports"


const useReport = () => {

    const [reportPerformance, setReportPerformance] = useState(null);
    const [geolocationVerification, setGeolocationVerification] = useState(null)

    const [isLoading, setIsLoading] = useState(false);
    const [loadingVerification, setIsLoadingVerification] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [anomalyList, setAnomalylist] = useState(null)
    const [isLoadingAnomaly, setIsLoadingAnomaly] = useState(false)
    const [alertList, setAlertList] = useState([]);
    const [isLoadingAlertList, setIsLoadingAlertList] = useState(false);
    const [listVerificationFrequency, setListVerificationFrequency] = useState(null);
    const [loadingVerificationFrequency, setLoadingVerificationFrequency] = useState(false);
    const [isLoadingProductVerification, setIsLoadingProductVerification] = useState(false);
    const [listProductVerification, setListProductVerification] = useState(null);
    const [userActivityList, setUserActivityList] = useState(null)
    const [isLoadingUserActivity, setIsLoadingUserActivity] = useState(false)

    var limit = 5;
    var type = 1;

    const getAuthenticationPerformance = (data) => {
        setIsLoading(true)
        ReportService.getAuthenticationPerformance(data).then((res)=>{
            console.log('get authentication perfomance res here', res)
            if(res.data.success){
                setIsLoading(false)
                setReportPerformance(res.data.data)

            }
        }).catch((error)=>{
            setIsLoading(false)
            console.log('error get authentication performance', error)
        })
    }

    const getGeolocationVerification = (data) => {
        setIsLoadingVerification(true)
        ReportService.getGeolocationVerification(data).then((res)=>{
            console.log('get geolocation verification res bbbbbbbbbbbbbbb', res)
            if(res.data.success){
                setIsLoadingVerification(false)
                setGeolocationVerification(res.data.data)
            }
        }).catch((error)=>{
            setIsLoadingVerification(false)
            console.log('error get authentication performance', error)
        })
    }

    const getAnomalyDetection = (data) => {
        setIsLoadingAnomaly(true)
        ReportService.getAnomalyDetection(data).then((res)=>{
            console.log('get geolocation verification res bbbbbbbbbbbbbbb', res)
            if(res.data.success){
                setIsLoadingAnomaly(false)
                setAnomalylist(res.data.data)
            }
        }).catch((error)=>{
            setIsLoadingAnomaly(false)
            console.log('error get geolocation verification', error)
        })
    }

    const getAlertList = (data) => {
        setIsLoadingAlertList(true)
        ReportService.getAlertList(data).then((res)=>{
            console.log('get alert list res bbbbbbbbbbbbbbb', res)
            if(res.data.success){
                setIsLoadingAlertList(false)
                setAlertList(res.data.data)
            }
        }).catch((error)=>{
            setIsLoadingAlertList(false)
            console.log('error get lert list err', error)
        })
    }

    const getVerificationFrequency = (data) => {
        setLoadingVerificationFrequency(true)
        ReportService.getVerificationFrequency(data).then((res)=>{
            console.log('get verification frequency res bbbbbbbbbbbbbbb', res)
            if(res.data.success){
                setLoadingVerificationFrequency(false)
                setListVerificationFrequency(res.data.data)
            }
        }).catch((error)=>{
            setLoadingVerificationFrequency(false)
            console.log('error verification frequency list err', error)
        })
    }

    const getProductVerification = (data) => {
        setIsLoadingProductVerification(true)
        ReportService.getProductVerification(data).then((res)=>{
            console.log('get product verification res bbbbbbbbbbbbbbb', res.data.data)
            if(res.data.success){
                setIsLoadingProductVerification(false)
                setListProductVerification(res.data.data)
            }
        }).catch((error)=>{
            setIsLoadingProductVerification(false)
            console.log('error product verification list err', error)
        })
    }

    const getUserActivity = (data) => {
        setIsLoadingUserActivity(true)
        ReportService.getUserActivity(data).then((res)=>{
            console.log('get UserActivity res bbbbbbbbbbbbbbb', res.data.data)
            if(res.data.success){
                setIsLoadingUserActivity(false)
                setUserActivityList(res.data.data)
            }
        }).catch((error)=>{
            setIsLoadingUserActivity(false)
            console.log('error get UserActivity list err', error)
        })
    }


    return {getAuthenticationPerformance, reportPerformance, isLoading, pagination, getGeolocationVerification, setIsLoadingVerification, 
        geolocationVerification, loadingVerification, getAnomalyDetection, anomalyList, isLoadingAnomaly, getAlertList, alertList, isLoadingAlertList, 
        getVerificationFrequency,loadingVerificationFrequency, listVerificationFrequency, getProductVerification, isLoadingProductVerification, listProductVerification,
        userActivityList, isLoadingUserActivity, getUserActivity
    }
}
export default useReport